import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'Cross',
  props: {
    opaque: Boolean,
    black: Boolean,
},
  setup(__props) {

/* White by default */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["cross icon icon--close", {
        'cross--opaque': __props.opaque,
        'cross--black': __props.black
    }])
  }, null, 2 /* CLASS */))
}
}

})